// @flow
import * as React from 'react';
import styled from 'styled-components';
import { getAvatar } from '../../modules/selectors';

const AvatarWrapper = styled.div`
	border-radius: 50%;
	overflow: hidden;
`;

const AvatarImg = styled.img`
	display: block;
	width: 100%;
`;

type Props = {
	user_id: number,
	avatar_version: number,
	className?: string
};

export const TeamUserAvatar = ({ user_id, avatar_version, className }: Props) => {
	const src = getAvatar({ user_id, avatar_version });

	return (
		<AvatarWrapper className={className}>
			<AvatarImg src={src} alt="" />
		</AvatarWrapper>
	);
};

export default TeamUserAvatar;


// WEBPACK FOOTER //
// ./src/components/Team/TeamUserAvatar.js